import { render, staticRenderFns } from "./StudentExaminationPointManual.vue?vue&type=template&id=2b9271ba&"
import script from "./StudentExaminationPointManual.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationPointManual.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationPointManual.vue?vue&type=style&index=0&id=2b9271ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports